import { AxiosResponse } from 'axios';
import $api from '@/http/index';
import { ConfigService } from '@/configuration/services/configService';
import { ITreeOption } from '@/types';
import { IMenuItemInfo } from '@models/folders/IMenuItemInfo';

export class FoldersService {
    static async tasks(submenu: string): Promise<AxiosResponse<ITreeOption[]>> {
        return $api.get<ITreeOption[]>(`/folders/tasks/submenu/${submenu}`);
    }
    static async documents(submenu: string): Promise<AxiosResponse<ITreeOption[]>> {
        return $api.get<ITreeOption[]>(`/folders/documents/submenu/${submenu}`);
    }
    static async dictionaries(submenu: string): Promise<AxiosResponse<ITreeOption[]>> {
        return $api.get<ITreeOption[]>(`/folders/dictionaries/submenu/${submenu}`);
    }
    static async reports(submenu: string): Promise<AxiosResponse<ITreeOption[]>> {
        return $api.get<ITreeOption[]>(`/folders/reports/submenu/${submenu}`);
    }
    static async dashboards(submenu: string): Promise<AxiosResponse<ITreeOption[]>> {
        return $api.get<ITreeOption[]>(`/folders/dashboards/submenu/${submenu}`);
    }
    static async root(): Promise<AxiosResponse<ITreeOption[]>> {
        const response = await $api.get<ITreeOption[]>('/folders/root');
        // Раздел скрывает и бэкенд (выключенная платформа, нет доступных дашбордов), здесь —
        // только явное выключение в конфигурации фронта.
        if (ConfigService.get().application.dashboards?.enabled !== false) return response;
        return {
            ...response,
            data: response.data.filter((item) => item.value.split('/')[0].toLowerCase() !== 'dashboards'),
        };
    }

    static async fetchDocumentsInfo(name: string, submenu: string): Promise<AxiosResponse<IMenuItemInfo, any>> {
        return $api.get<IMenuItemInfo>(`/folders/documents/info/${name}/submenu/${submenu}`);
    }
    static async fetchTasksInfo(name: string, submenu: string): Promise<AxiosResponse<IMenuItemInfo, any>> {
        return $api.get<IMenuItemInfo>(`/folders/tasks/info/${name}/submenu/${submenu}`);
    }
}
